<template>
  <div id="dashboard">
    <!-- <div class="block block-rounded block-bordered"> -->
    <!-- <div class="block-header block-header-default">
        <h3 class="block-title">实体卡管理</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create('add')"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
    </div>-->
    <!-- <div class="block-content block-content-full"> -->
    <div class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="row mb-1">
        <div class="col-12 col-md-4 text-center text-md-left">
          <pageSize @changePageSize="changePageSize"></pageSize>
        </div>
        <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
          <div class="dt-buttons">
            <button
              class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
              tabindex="0"
              aria-controls="DataTables_Table_1"
              data-clipboard-text
              @click="copy()"
              type="button"
              id="copybtnCarportCard"
            >
              <span>复制</span>
            </button>
            <button
              class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
              @click="exportCSV()"
              type="button"
            >
              <span>导出</span>
            </button>
            <button
              class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
              @click="print()"
            >
              <span>打印</span>
            </button>
          </div>
        </div>
        <div class="col-12 col-md-4 text-center text-md-right">
          <div class="dataTables_filter">
            <label>
              <input
                type="search"
                class="form-control"
                placeholder="搜索"
                v-model="key"
                @keyup.enter="search()"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="table-responsive">
            <section ref="print">
              <p class="show-on-print print-title">实体卡管理</p>
              <table
                class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
              >
                <thead>
                  <tr>
                    <th
                      class="text-center sorting"
                      style="width: 60px; min-width:60px"
                      @click="getList('ID',$event)"
                    >#</th>
                    <th
                      class="text-left sorting"
                      style="width: 200px;min-width: 200px;"
                      @click="getList('CARD_NO',$event)"
                    >实体卡号</th>
                    <th
                      class="text-left sorting d-md-table-cell"
                      style="width: 200px;min-width: 200px;"
                      @click="getList('USER_ID',$event)"
                    >关联用户ID</th>
                    <th
                      class="text-left sorting"
                      style="width: 200px;min-width: 200px;"
                      @click="getList('MOBILE_PHONE',$event)"
                    >关联手机号码</th>
                    <th
                      class="text-center d-xl-table-cell sorting"
                      style="width: 120px; min-width:120px"
                      @click="getList('CARD_BIND_STATE',$event)"
                    >卡片状态</th>
                    <th
                      class="text-center d-xl-table-cell no-print"
                      style="width: 100px; min-width:100px"
                      v-if="editBtn || stateBtn"
                    >操作</th>
                  </tr>
                </thead>
                <tbody v-if="cards.length">
                  <tr v-for="(item, i) in cards" :key="i">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td class="text-left">{{ item.CARD_NO }}</td>
                    <td class="text-left d-md-table-cell">{{ item.USER_ID }}</td>
                    <td class="text-left">{{ item.MOBILE_PHONE }}</td>
                    <td class="text-center d-xl-table-cell">
                      <!-- 0未绑 2解绑 3挂失 -->
                      <i
                        :class="{'fa fa-check-circle text-success':item.CARD_BIND_STATE == '2','fa fa-times-circle text-danger':item.CARD_BIND_STATE == '3','fa fa-minus-circle text-secondary ':item.CARD_BIND_STATE == '0'}"
                      ></i>
                    </td>
                    <td class="text-center d-xl-table-cell no-print" v-if="editBtn || stateBtn">
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-primary js-tooltip-enabled"
                          data-toggle="modal"
                          title="查看"
                          @click="$router.push({name:'carportWhiteUser', params:{id:item.USER_ID,val:key,type:'see'}})"
                          data-original-title="Edit"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-if="stateBtn"
                          type="button"
                          class="btn btn-primary js-tooltip-enabled"
                          title="修改卡片状态"
                          data-original-title="Edit"
                          data-toggle="modal"
                          @click="create('changeState',item)"
                        >
                          <i class="fa fa-tasks"></i>
                        </button>
                        <!-- <button
                              title="绑定"
                              v-if="editBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="modal"
                              @click="create('edit',item)"
                            >
                              <i class="fa fa-link"></i>
                            </button>
                            <button
                              v-if="stateBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="解绑"
                              data-original-title="Edit"
                              data-toggle="modal"
                              @click="create('changeState',item)"
                            >
                              <i class="fa fa-unlink"></i>
                        </button>-->
                        <!-- 2020.1.15去除
                            <button
                              v-if="stateBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="修改卡片状态"
                              data-original-title="Edit"
                              data-toggle="modal"
                              @click="createSet(item)"
                            >
                              <i class="fa fa-user-cog"></i>
                        </button>-->
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="7">查无数据</td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
          <div class="dataTables_info" role="status" aria-live="polite">
            页数
            <strong>{{ page }}</strong> /
            <strong>{{ totalPage }}</strong>
          </div>
        </div>
        <div class="col-sm-12 col-md-7 text-center text-md-right">
          <div class="dataTables_paginate paging_full_numbers">
            <el-pagination
              v-if="cards && cards.length"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="pageSize"
              :small="isMobile"
              :pager-count="pagerCount"
              :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
              :total="total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- </div> -->
    <div
      class="modal fade"
      id="modal-default-normal-all"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-all"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
            >{{edit=='add'?'新增实体卡':edit=='edit'?'绑定实体卡':edit=='changeState'?"修改卡片状态":"实体卡信息"}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit!='add'"
                    class="form-control"
                    placeholder
                    maxlength="10"
                    v-model="form.cardNo"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='add'||edit=='edit'">
                <label class="col-sm-12 control-label">{{edit=='add'?'关联方式':'绑定方式'}}</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="bill-type"
                    name="bill-type"
                    v-model="form.relationType"
                    @change="changeType()"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in typeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">关联用户ID</label>
                <div class="col-sm-12">
                  <input
                    :disabled="form.relationType!='1'"
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.userid"
                  />
                </div>
              </div>

              <div class="form-group" :class="{'form-group-50':edit=='changeState'||edit==''}">
                <label for="example-text-input" class="col-sm-12 control-label">关联手机号码</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="11"
                    v-model="form.phone"
                    :disabled="form.relationType!='2'"
                  />
                </div>
              </div>
              <!-- <div class="form-group form-group-50" v-show="edit==''">
                <label     class="col-sm-12 control-label">启用时间</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="bindTime"
                    disabled
                  />
                </div>
              </div>-->
              <div
                class="form-group"
                :class="{'form-group-50':edit==''}"
                v-show="edit==''||edit=='changeState'"
              >
                <label class="col-sm-12 control-label">卡片状态</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.bindState" :disabled="edit==''">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in bindStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit==''">
                <label class="col-sm-12 control-label">卡片状态</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="form.state"
                    :disabled="edit==''||form.bindState=='1'"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cardStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              v-if="edit!=''"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      cards: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      form: {
        phone: "",
        cardNo: "",
        remark: "",
        id: "",
        state: "",
        userid: "",
        relationType: "",
        bindState: ""
      },
      bindTime: "",
      edit: "",
      cardStatus: [
        {
          value: 1,
          label: "启用"
        },
        {
          value: 2,
          label: "禁用"
        }
      ],
      bindStatus: [
        {
          value: 2,
          label: "解绑（卡片内没有余额，解绑后可重新绑定）"
        },
        {
          value: 1,
          label: "挂失（挂失后卡片作废，无法再次绑定和使用）"
        }
      ],
      typeList: [
        {
          value: 1,
          label: "用户ID"
        },
        {
          value: 2,
          label: "手机号码"
        }
      ],
      sorting: "",
      orderBy: false,
      addBtn: Util.isHavePerm("card/insertCardInfo"),
      editBtn: Util.isHavePerm("card/bindCard"),
      stateBtn: Util.isHavePerm("card/updateCardInfoState")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    },
    "form.cardNo"(val, oldVal) {
      this.form.cardNo = Util.isNumber(val);
    },
    "form.phone"(val, oldVal) {
      this.form.phone = Util.isNumber(val);
    },
    "form.userid"(val, oldVal) {
      this.form.userid = Util.isNumber(val);
      this.form = Object.assign({}, this.form);
    }
  },
  mounted() {
    // this.getEntry()
    this.getList();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changeType() {
      if (this.form.relationType == "1") {
        this.form.phone = "";
      } else if (this.form.relationType == "2") {
        this.form.userid = "";
      }
    },
    formatTimeG(val) {
      return Util.formatTimeG(val);
    },
    // 禁用卡片
    createSet(val) {
      let text = val.STATE == 1 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.switchChange(val);
            break;
        }
      });
    },
    switchChange(val) {
      this.$http
        .post(`${Util.operateURL}/card/updateCardInfoState`, {
          cardNo: val.CARD_NO,
          state: val.STATE == 1 ? 2 : 1
        })
        .then(res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        }),
        err => {
          console.log(err);
        };
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getEntry() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/Info/${this.$route.params.id}`)
        .then(result => {
          this.entry = result.data.data;
          this.$store.commit("setParam", {
            entry: this.entry
          });
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByCardUser/${this.page}/${this.pageSize}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.cards = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showState(str) {
      switch (str) {
        case "0":
          return "未绑定";
        case "1":
          return "已解绑";
        case "2":
          return "已绑定";
        case "3":
          return "已挂失";
      }
    },
    create(val, id) {
      jQuery("#modal-default-normal-all").modal("show");
      this.edit = val;
      if (this.edit == "add") {
        this.form = {
          phone: "",
          cardNo: "",
          remark: "",
          state: 1,
          relationType: ""
        };
      } else {
        this.form = {
          phone: id.MOBILE_PHONE,
          cardNo: id.CARD_NO,
          remark: id.REMARK,
          state: id.USE_STATE,
          userid: id.USER_ID,
          relationType: id.RELATION_TYPE ? id.RELATION_TYPE : "",
          bindState:
            id.CARD_BIND_STATE == 3 ? 1 : id.CARD_BIND_STATE == 1 ? 2 : ""
        };
        this.bindTime = id.BIND_TIME;
      }
    },
    delUser(id, val) {
      this.$http
        .post(`${Util.operateURL}/card/updateCardUser`, {
          phone: val.MOBILE_PHONE,
          cardNo: val.CARD_NO
        })
        .then(res => {
          if (res.data.code == 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        });
    },
    submit() {
      let url = "";
      if (this.edit == "add") {
        url = `${Util.operateURL}/card/insertCardInfo`;
      } else if (this.edit == "edit") {
        url = `${Util.operateURL}/card/bindCard`;
      } else {
        url = `${Util.operateURL}/card/updateCardInfoState`;
        this.form.state = "";
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal-all").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByCardUser/${this.page}/${this.pageSize}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[2].innerText;
      var btn = document.getElementById("copybtnCarportCard");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    }
  }
};
</script>